import __vue_component__$3 from '../Tooltip/Tooltip.vue.js';
import __vue_component__$2 from '../Dropdown/DropdownItem.vue.js';
import __vue_component__$1 from '../Dropdown/Dropdown.vue.js';
import __vue_component__ from './Avatar.vue.js';

//
var script = {
  name: 'AvatarGroup',
  components: {
    Avatar: __vue_component__,
    Dropdown: __vue_component__$1,
    DropdownItem: __vue_component__$2,
    Tooltip: __vue_component__$3
  },
  props: {
    users: {
      type: Array,
      default: () => []
    },
    size: {
      type: String,
      default: 'medium'
    },
    borderColor: {
      type: String,
      default: '#fff'
    },
    limit: {
      type: Number,
      default: 5
    },
    dropdownPositionFixed: {
      type: Boolean,
      default: false
    },
    appendToBody: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      counterUp: true
    };
  },

  computed: {
    isOverLimit() {
      return this.users && this.users.length > this.limit;
    },

    count() {
      return this.visible.length;
    },

    visible() {
      return this.users ? this.users.slice(0, this.limit) : [];
    },

    collapsed() {
      return this.users ? this.users.slice(this.limit - 1) : [];
    },

    collapsedCount() {
      return this.collapsed.length;
    }

  },
  watch: {
    collapsedCount(value, prevValue) {
      this.counterUp = value > prevValue;
    }

  },
  methods: {
    beforeLeave(el) {
      el.style.left = `${el.offsetLeft}px`;
      el.style.top = `${el.offsetTop}px`;
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Avatar/AvatarGroup.vue_rollup-plugin-vue=script.js